import { activityLogStore } from "../stores";

export const useActivityLogStore = () => activityLogStore;
